import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\FetchEventPlanningOfTheDayController::__invoke
* @see app/Http/Controllers/Planning/FetchEventPlanningOfTheDayController.php
* @route '/api/planning/fetch-events-of-the-day'
*/
const FetchEventPlanningOfTheDayController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchEventPlanningOfTheDayController.url(options),
    method: 'post',
})

FetchEventPlanningOfTheDayController.definition = {
    methods: ["post"],
    url: '/api/planning/fetch-events-of-the-day',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Planning\FetchEventPlanningOfTheDayController::__invoke
* @see app/Http/Controllers/Planning/FetchEventPlanningOfTheDayController.php
* @route '/api/planning/fetch-events-of-the-day'
*/
FetchEventPlanningOfTheDayController.url = (options?: RouteQueryOptions) => {
    return FetchEventPlanningOfTheDayController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\FetchEventPlanningOfTheDayController::__invoke
* @see app/Http/Controllers/Planning/FetchEventPlanningOfTheDayController.php
* @route '/api/planning/fetch-events-of-the-day'
*/
FetchEventPlanningOfTheDayController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchEventPlanningOfTheDayController.url(options),
    method: 'post',
})

export default FetchEventPlanningOfTheDayController